(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["premium-product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    const option = e.target.closest('[data-option-position]');
    if (!option) return;

    const card = option.closest('.lux-card');
    const variants = JSON.parse(card.querySelector('.lux-variants').textContent);
    const variantInput = card.querySelector('.variant-id');
    const priceBox = card.querySelector('.js-price');

    let selectedOptions = card.selectedOptions || [];

    const position = parseInt(option.dataset.optionPosition);
    const value = option.dataset.value;

    option.parentElement.querySelectorAll('[data-option-position]').forEach((el) => el.classList.remove('active'));
    option.classList.add('active');

    selectedOptions[position - 1] = value;
    card.selectedOptions = selectedOptions;

    const variant = variants.find((v) => v.options.every((opt, i) => opt === selectedOptions[i]));
    if (!variant) return;

    variantInput.value = variant.id;

    if (priceBox) {
      priceBox.innerHTML = Shopify.formatMoney(variant.price);
    }

    if (variant.featured_image) {
      const img = card.querySelector('.lux-card__image.primary');
      img.src = variant.featured_image.src;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-filters-and-sort"] && !Shopify.designMode) return;
  try {
    (function() {

    // ── Desktop sort dropdown ──────────────────────────
    const sortTrigger = document.querySelector('.js-sort-trigger');
    const sortDropdown = document.querySelector('.js-sort-dropdown');

    if (sortTrigger && sortDropdown) {
        sortTrigger.addEventListener('click', function(e) {
            e.stopPropagation();
            const isOpen = sortDropdown.classList.contains('is-open');
            sortDropdown.classList.toggle('is-open', !isOpen);
            sortTrigger.setAttribute('aria-expanded', String(!isOpen));
        });

        // Close when clicking outside
        document.addEventListener('click', function(e) {
            if (!sortTrigger.contains(e.target) && !sortDropdown.contains(e.target)) {
                sortDropdown.classList.remove('is-open');
                sortTrigger.setAttribute('aria-expanded', 'false');
            }
        });
    }

    // ── Mobile sort bottom sheet ───────────────────────
    const sortSheet    = document.querySelector('.js-sort-sheet');
    const sheetClose   = document.querySelectorAll('.js-sort-sheet-close, .js-sort-sheet-backdrop');
    const mobileSortBtn = document.querySelector('.product-filters__split-btn--sort');

    function isMobile() {
        return window.innerWidth < 768;
    }

    if (mobileSortBtn && sortSheet) {
        mobileSortBtn.addEventListener('click', function(e) {
            if (isMobile()) {
                e.preventDefault();
                e.stopPropagation();
                sortSheet.classList.add('is-open');
                document.body.style.overflow = 'hidden';
            }
        });

        sheetClose.forEach(function(el) {
            el.addEventListener('click', function() {
                sortSheet.classList.remove('is-open');
                document.body.style.overflow = '';
            });
        });
    }

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-highlight-accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.product-accordion .accordion-header');
  accordions.forEach(header => {
    header.addEventListener('click', function() {
      const content = header.nextElementSibling;
      const isOpen = content.style.maxHeight && content.style.maxHeight !== "0px";
      
      if (isOpen) {
        content.style.maxHeight = null;
        header.classList.remove('active'); 
        header.querySelector('.accordion-icon').textContent = '+';
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
        header.classList.add('active'); 
        header.querySelector('.accordion-icon').textContent = '-';
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-title"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
		const wishlistButtons = document.querySelectorAll(".js-wishlist-toggle");

		function getWishlist() {
			const raw = JSON.parse(localStorage.getItem("wishlist") || "[]");
			return raw.map(item => {
				if (typeof item === "object" && item.id) return { id: String(item.id), handle: item.handle || null };
				return { id: String(item), handle: null };
			});
		}

		function saveWishlist(list) {
			localStorage.setItem("wishlist", JSON.stringify(list));
		}

		function isWishlisted(list, id) {
			return list.some(item => item.id === String(id));
		}

		let wishlist = getWishlist();

		wishlistButtons.forEach(btn => {
			const productId     = btn.dataset.productId;
			const productHandle = btn.dataset.productHandle;

			if (isWishlisted(wishlist, productId)) {
				btn.classList.add("active");
			}

			btn.addEventListener("click", () => {
				wishlist = getWishlist();

				if (isWishlisted(wishlist, productId)) {
					wishlist = wishlist.filter(item => item.id !== String(productId));
					btn.classList.remove("active");
				} else {
					wishlist.push({ id: String(productId), handle: productHandle });
					btn.classList.add("active");
				}

				saveWishlist(wishlist);
			});
		});
	});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
		function getWishlist() {
			var raw = JSON.parse(localStorage.getItem('wishlist') || '[]');
			return raw.map(function (item) {
				if (typeof item === 'object' && item.id) return { id: String(item.id), handle: item.handle || null };
				return { id: String(item), handle: null };
			});
		}

		function saveWishlist(list) {
			localStorage.setItem('wishlist', JSON.stringify(list));
		}

		function isWishlisted(list, id) {
			return list.some(function (item) { return item.id === String(id); });
		}

		function init() {
			var toggles = document.querySelectorAll('.wishlist-card__icon-toggle.js-wishlist-toggle');
			var wishlist = getWishlist();

			toggles.forEach(function (toggle) {
				var id     = toggle.dataset.productId;
				var handle = toggle.dataset.productHandle;

				if (isWishlisted(wishlist, id)) {
					toggle.classList.add('active');
					toggle.setAttribute('aria-pressed', 'true');
				}

				toggle.addEventListener('click', function () {
					wishlist = getWishlist();
					if (isWishlisted(wishlist, id)) {
						wishlist = wishlist.filter(function (item) { return item.id !== String(id); });
						toggle.classList.remove('active');
						toggle.setAttribute('aria-pressed', 'false');
					} else {
						wishlist.push({ id: String(id), handle: handle });
						toggle.classList.add('active');
						toggle.setAttribute('aria-pressed', 'true');
					}
					saveWishlist(wishlist);
				});

				toggle.addEventListener('keydown', function (e) {
					if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle.click(); }
				});
			});
		}

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', init);
		} else {
			init();
		}
	})();
  } catch(e) { console.error(e); }
})();

})();
